const chunkLoadReloadKey = 'chunk-load-reload';

export function isChunkLoadFailure(error: unknown): boolean {
    const maybeError = error as { name?: string; message?: string; type?: string; target?: { src?: string } } | null | undefined;
    const message = maybeError?.message ?? '';

    return (
        maybeError?.name === 'ChunkLoadError' ||
        /Loading chunk [\dA-Za-z_-]+ failed/i.test(message) ||
        /ChunkLoadError/i.test(message) ||
        (maybeError?.type === 'error' && /\/dist\/.+\.js(?:\?|$)/i.test(maybeError?.target?.src ?? ''))
    );
}

export function reloadForChunkLoadFailure() {
    const browserStorage = globalThis.sessionStorage;

    if (browserStorage?.getItem(chunkLoadReloadKey) === globalThis.location.href) {
        browserStorage.removeItem(chunkLoadReloadKey);
        return;
    }

    browserStorage?.setItem(chunkLoadReloadKey, globalThis.location.href);
    globalThis.location.reload();
}

export function recoverFromChunkLoadFailure(error: unknown): boolean {
    if (!isChunkLoadFailure(error)) {
        return false;
    }

    reloadForChunkLoadFailure();
    return true;
}
